"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require("styled-system");

var _themed = require("../../utils/themed");

var _themed2 = _interopRequireDefault(_themed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Box = exports.Box = _styledComponents2.default.div.withConfig({
  displayName: "Box",
  componentId: "sc-16jnm6k-0"
})(["box-sizing:border-box;", " ", " ", " ", " ", " ", " ", " ", " ", ""], _styledSystem.space, _styledSystem.layout, _styledSystem.position, _styledSystem.typography, _styledSystem.color, _styledSystem.flexbox, _styledSystem.border, _styledSystem.boxShadow, (0, _themed2.default)("Box"));

Box.propTypes = _extends({}, _styledSystem.space.propTypes, _styledSystem.layout.propTypes, _styledSystem.position.propTypes, _styledSystem.typography.propTypes, _styledSystem.color.propTypes, _styledSystem.flexbox.propTypes, _styledSystem.border.propTypes, _styledSystem.boxShadow.propTypes);

Box.defaultProps = {
  fontFamily: "Uni Neue",
  borderColor: "palette.ink.300"
};

/** @component */
exports.default = Box;